import { Reducer } from 'redux';
import { LogoutLocalState, LogoutLocalActionTypes } from './types';

export const initialState: LogoutLocalState = {};

const reducer: Reducer<LogoutLocalState> = (
  state = initialState,
  action: any
) => {
  switch (action.type) {
    case LogoutLocalActionTypes.LOGOUT_START:
      return {
        ...state,
        status: 'loging-out'
      };
    case LogoutLocalActionTypes.LOGOUT_SUCCESS:
      return {
        ...state,
        status: 'loged-out'
      };
    case LogoutLocalActionTypes.LOGOUT_FAILURE:
      return {
        ...state,
        status: 'failed-log-out'
      };
    default:
      return state;
  }
};

export default reducer;
